export default __webpack_public_path__ + "static/media/posture.761ca2d1.png";